var CallTaskState = /* @__PURE__ */ ((CallTaskState2) => {
  CallTaskState2["Done"] = "Done";
  CallTaskState2["Done_AvailyBooking"] = "Done_AvailyBooking";
  CallTaskState2["Open"] = "Open";
  CallTaskState2["Ignored"] = "Ignored";
  CallTaskState2["Open_UnsuccessfulCallback"] = "Open_UnsuccessfulCallback";
  CallTaskState2["Open_Ringing"] = "Open_Ringing";
  CallTaskState2["Open_InProgress"] = "Open_InProgress";
  return CallTaskState2;
})(CallTaskState || {});
var CallTaskActionType = /* @__PURE__ */ ((CallTaskActionType2) => {
  CallTaskActionType2["CallBack"] = "CallBack";
  CallTaskActionType2["Ignore"] = "Ignore";
  CallTaskActionType2["Ignored"] = "Ignored";
  CallTaskActionType2["UnsuccessfulCallBack"] = "UnsuccessfulCallBack";
  return CallTaskActionType2;
})(CallTaskActionType || {});
var ServerSentResourceType = /* @__PURE__ */ ((ServerSentResourceType2) => {
  ServerSentResourceType2["ANAMNESIS"] = "ANAMNESIS";
  ServerSentResourceType2["APPOINTMENT"] = "APPOINTMENT";
  ServerSentResourceType2["CALL_TASK"] = "CALL_TASK";
  ServerSentResourceType2["TEXT_MESSAGE"] = "TEXT_MESSAGE";
  ServerSentResourceType2["CONVERSATION"] = "CONVERSATION";
  ServerSentResourceType2["TODO_LIST_TASK"] = "TODO_LIST_TASK";
  ServerSentResourceType2["PATIENT"] = "PATIENT";
  ServerSentResourceType2["OPEN_APPOINTMENT"] = "OPEN_APPOINTMENT";
  ServerSentResourceType2["PATIENT_CREDITWORTHINESS"] = "PATIENT_CREDITWORTHINESS";
  return ServerSentResourceType2;
})(ServerSentResourceType || {});
var ChemistryRating = /* @__PURE__ */ ((ChemistryRating2) => {
  ChemistryRating2["NORMAL"] = "NORMAL";
  ChemistryRating2["PLUS"] = "PLUS";
  ChemistryRating2["MINUS"] = "MINUS";
  ChemistryRating2["STOP"] = "STOP";
  return ChemistryRating2;
})(ChemistryRating || {});
export {
  CallTaskActionType,
  CallTaskState,
  ChemistryRating,
  ServerSentResourceType
};
